import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';


const Instructions = ({ props, isAccordion, setIsAccordion }) => {
  const stateProps = props.stateProps;
  const sectionName = stateProps.sectionData.sectionName;
  const navSection = props.navSections[sectionName];
  const handleAccordionToggle = () => {
    setIsAccordion(!isAccordion);
  };
  return (

    <Box>
    </Box>
  );

};
export default Instructions;
/*

      <Box>
        <Text fontWeight="bold">Instructions go here:</Text>
        <Text variant="sectionText">{navSection.tagline} The quick brown fox jumped over the lazy dog. The quick
          brown fox jumped over the lazy dog. The quick brown fox jumped over the lazy dog.</Text>

      </Box>

      <Box display="flex" justifyContent="flex-end">
        <Box width="70%" marginBottom=".5rem">
          <Button _hover={{ color: 'white' }} float="right" height="auto"
                  padding=".3rem .5rem !important"
                  width="auto"
                  color="black"
                  backgroundColor="#FF914D !important"
                  onClick={() => {
                    handleAccordionToggle();
                  }}
          >Toggle Display</Button>
        </Box>
      </Box>
 */